module.exports = __webpack_public_path__ + "img/cosmetics-1.1666e22c.png";